import React, { useState } from 'react'
import styled from 'styled-components'
import axios from 'axios'
const RefundForm = (props) => {
    const [paymentSlip, setPaymentSlip] = useState(null)
    const [cancelledCheque, setCancelledCheque] = useState(null)
    const onSubmit = async (e) => {
        const file = e.target.files[0]
        const formData = new FormData();
        formData.append("file", file);
        // Make an API call to upload the file
        fetch(`/api/v2/file-upload`, {
            method: 'POST',
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                // Handle the response from the API
                // alert('success')
                setPaymentSlip(data.data)
                alert("Document Has been Uploaded Successfully")

                console.log(data);
            })
            .catch((error) => {
                // Handle errors from the API call
                alert('Something went wrong')
                console.error(error);
            });
    }
    const onSubmit2 = async (e) => {

        // alert('helo')
        const file = e.target.files[0]
        const formData = new FormData();
        formData.append("file", file);
        // Make an API call to upload the file
        fetch(`/api/v2/file-upload`, {
            method: 'POST',
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                alert("Document Has been Uploaded Successfully")
                // Handle the response from the API
                // alert('success')
                setCancelledCheque(data.data)
                console.log(data);
            })
            .catch((error) => {
                // Handle errors from the API call
                alert('something went wrong')
                console.error(error);
            });
    }


    const [applicationNo, setApplicationNo] = useState('')
    const [studentName, setStudentName] = useState('')
    const [refundOf, setrefundOf] = useState('')
    const [accoundHolderName, setaccoundHolderName] = useState('')
    const [accountType, setAccountType] = useState('')
    const [accountNo, setaccountNo] = useState('')
    const [confAccountNo, setconfAccountNo] = useState('')
    const [bankName, setbankName] = useState('')
    const [ifscCode, setifscCode] = useState('')


    const finalSubmit = async (e) => {
        e.preventDefault()
        axios.post(`/refund/student/${props.data._id}`, {
            applicationNo, studentName, refundOf, accoundHolderName, accountType, accountNo, confAccountNo, bankName, ifscCode,
            paymentSlip, cancelledCheque
        })
            .then(function (response) {
                console.log(response.data.message)
                alert(response.data.message)
                props.onClick()
                // alert('College Choices saved successfully')
            })
            .catch(function (error) {
                alert(error.response.data.message)
                // alert(error.response.data.message)
            });
    }
    // const {applicationNo,studentName,refundOf,accoundHolderName,accountNo,confAccountNo,bankName,ifscCode} = req.body

    return (
        <Form>
           <div className="max-w-4xl mx-auto mt-8 bg-white shadow-lg rounded-lg p-6 sm:p-10 border-t-4 border-orange-500">
  <h2 className="text-2xl font-bold text-orange-600 text-center mb-6">
    AICEE 2026 Refund Request Form
  </h2>

  <form onSubmit={finalSubmit} className="space-y-5">

    {/* Application No */}
    <div>
      <label className="block font-medium mb-1">Application No <span className="text-red-500">*</span></label>
      <input
        type="number"
        className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
        placeholder="Enter Your Application No"
        value={applicationNo}
        onChange={(e) => setApplicationNo(e.target.value)}
        required
      />
    </div>

    {/* Student Name */}
    <div>
      <label className="block font-medium mb-1">Name of the Student <span className="text-red-500">*</span></label>
      <input
        type="text"
        className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
        placeholder="Enter Name of The Student"
        value={studentName}
        onChange={(e) => setStudentName(e.target.value)}
        required
      />
    </div>

    {/* Refund of */}
    <div>
      <label className="block font-medium mb-1">Refund of <span className="text-red-500">*</span></label>
      <select
        className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
        value={refundOf}
        onChange={(e) => setrefundOf(e.target.value)}
        required
      >
        <option value="">-- Select --</option>
        <option value="Counselling Fee">Counselling Fee</option>
        <option value="Seat Confirmation Fee">Seat Confirmation Fee</option>
      </select>
    </div>

    {/* Payment Slip */}
    <div>
      <label className="block font-medium mb-1">Payment Slip <span className="text-red-500">*</span></label>
      <input
        type="file"
        onChange={onSubmit}
        className="w-full border border-gray-300 rounded px-4 py-2 file:bg-gray-400 file:text-white file:border-none file:rounded"
        required
      />
    </div>

    {/* Account Holder Name */}
    <div>
      <label className="block font-medium mb-1">Account Holder Name <span className="text-red-500">*</span></label>
      <input
        type="text"
        className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
        placeholder="Account Holder Name"
        value={accoundHolderName}
        onChange={(e) => setaccoundHolderName(e.target.value)}
        required
      />
    </div>

    {/* Account Type */}
    <div>
      <label className="block font-medium mb-1">Account Type <span className="text-red-500">*</span></label>
      <select
        className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
        value={accountType}
        onChange={(e) => setAccountType(e.target.value)}
        required
      >
        <option value="">-- Select Account Type --</option>
        <option value="Savings">Savings</option>
        <option value="Current">Current</option>
      </select>
    </div>

    {/* Account No & Confirm */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <label className="block font-medium mb-1">Account No <span className="text-red-500">*</span></label>
        <input
          type="number"
          className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
          placeholder="Account No"
          value={accountNo}
          onChange={(e) => setaccountNo(e.target.value)}
          required
        />
      </div>
      <div>
        <label className="block font-medium mb-1">Confirm Account No <span className="text-red-500">*</span></label>
        <input
          type="number"
          className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
          placeholder="Confirm Account No"
          value={confAccountNo}
          onChange={(e) => setconfAccountNo(e.target.value)}
          required
        />
      </div>
    </div>

    {/* Bank Name */}
    <div>
      <label className="block font-medium mb-1">Bank Name <span className="text-red-500">*</span></label>
      <input
        type="text"
        className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
        placeholder="Bank Name"
        value={bankName}
        onChange={(e) => setbankName(e.target.value)}
        required
      />
    </div>

    {/* IFSC Code */}
    <div>
      <label className="block font-medium mb-1">IFSC Code <span className="text-red-500">*</span></label>
      <input
        type="text"
        className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
        placeholder="IFSC Code"
        value={ifscCode}
        onChange={(e) => setifscCode(e.target.value)}
        required
      />
    </div>

    {/* Cancelled Cheque */}
    <div>
      <label className="block font-medium mb-1">Cancelled Cheque / 1st Page of Passbook <span className="text-red-500">*</span></label>
      <input
        type="file"
        onChange={onSubmit2}
        className="w-full border border-gray-300 rounded px-4 py-2 file:bg-gray-400 file:text-white file:border-none file:rounded"
        required
      />
    </div>

    {/* Notes */}
    <div className="text-sm text-red-600 mt-2 space-y-1">
      <p className="font-semibold">Note:-</p>
      <p>• Don’t make any false claims, otherwise your refund will be restricted.</p>
      <p>• Don’t apply twice, otherwise your claim will be rejected.</p>
    </div>

    {/* Submit Button */}
    <div className="text-center">
      <button
        type="submit"
        className="mt-6 bg-orange-600 hover:bg-orange-700 text-white px-8 py-2 rounded-md text-lg shadow"
      >
        Submit
      </button>
    </div>
  </form>
</div>

        </Form>
    )
}

const Form = styled.main`
    input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance : textfield; /* Firefox */
}
`

export default RefundForm